/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Constants from "app_constants";
import Theme from "./theme";

const AdminView = () => {
  return (
    <Theme>
      {Constants.metaTag}

      <div className="columns">
        <div className="column is-3 box">
          <aside className="menu">
            <p className="menu-label">General</p>
            <ul className="menu-list">
              <li>
                <a>Job Ads</a>
              </li>
              <li>
                <a>Forms</a>
              </li>
            </ul>
            <p className="menu-label">Account</p>
            <ul className="menu-list">
              <li>
                <a>Team Settings</a>
              </li>
              <li>
                <a className="is-active">Manage Your Team</a>
                <ul>
                  <li>
                    <a>Members</a>
                  </li>
                  <li>
                    <a>Plugins</a>
                  </li>
                  <li>
                    <a>Add a member</a>
                  </li>
                </ul>
              </li>
              <li>
                <a>Invitations</a>
              </li>
              <li>
                <a>Cloud Storage Environment Settings</a>
              </li>
              <li>
                <a>Authentication</a>
              </li>
            </ul>
          </aside>
        </div>

        <div className="column is-9 box"></div>
      </div>
    </Theme>
  );
};

export default AdminView;
